import React from "react";
import { Col, Row, Card } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import "./qrcode-modal.scss";
import Buttons from "../../atoms/Buttons";
import { Link } from "react-router-dom";

const data = [
  {
    title: "Your mobile",
    subTitle: "Uploading documents will be done on your mobile phone",
    icon: "mobile",
  },
  {
    title: "Documents",
    subTitle: (
      <>
        1 x photo ID (a passport or driver’s licence)
        <br />
        Bank statement{" "}
      </>
    ),
    icon: "document",
  },
  {
    title: "A well lit space",
    subTitle:
      "The best chance to get a clear image of yourself and your documents",
    icon: "well-lit",
  },
];
const QRCodeModal = (props) => {
  data[1]["subTitle"] = props?.requiredDocumentList;
  const QRcodeBase64 = props?.QRcodeBase64;
  const QRcodeURL = props?.QRcodeURL;
  return (
    <div className="qr-code-modal-container">
      <Link to="" className="qr-modal-close" data-testid="close-link">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
          testId="close-icon"
        />
      </Link>
      <Col xs={12} className="qr-heading-section">
        <p className="qr-heading">
          {props.modalTitle} Updating {props?.modalShowField}
        </p>
        <span className="qr-heading-sub-text">
          To update your details, we need to verify a few things. Please scan
          this QR code from any mobile device and provide a photo ID (for
          example, driver’s license, passport, or residence permit) plus one
          document from the document list below (from a mobile device, press
          continue when ready).
        </span>
      </Col>
      <Row className="justify-content-evenly qr-body-section">
        <Col lg={5} className="mt-5 pe-0">
          <p className="qr-body-heading">You will need</p>
          {data.map((item, index) => {
            return (
              <Row key={index} className="qr-card mb-3">
                <Col
                  lg={2}
                  sm={2}
                  xs={2}
                  className="d-none d-lg-block d-xs-none d-md-none d-sm-none p-0"
                >
                  {" "}
                  <Icons
                    iconname={item.icon}
                    variant="icon-fourty-eight-px"
                    testId={`icon-${index}`}
                  />
                </Col>
                <Col
                  lg={2}
                  sm={2}
                  xs={2}
                  className="d-block d-lg-none d-xs-block d-md-block d-sm-block"
                >
                  {" "}
                  <Icons
                    iconname={item.icon}
                    variant="icon-thirty-two-px"
                    testId={`icon-${index}`}
                  />
                </Col>
                <Col
                  lg={10}
                  sm={10}
                  xs={10}
                  className="p-0 ps-2 p-span-text-wrapper"
                >
                  <p>{item.title}</p>
                  <span>{item.subTitle}</span>
                </Col>
              </Row>
            );
          })}
        </Col>
        <Col
          lg={4}
          className="d-none d-lg-block d-xs-none d-md-none d-sm-none mt-5 text-center scanner-card"
        >
          <Card className="qr-scanner">
            <Card.Footer className="Scan-to-continue-text">
              <div className="qrcode-img">
                <img src={QRcodeBase64} alt="QR code" />
              </div>
              Scan to continue
            </Card.Footer>
          </Card>
          <span>
            Please use a smart phone camera or QR code reader to scan this code
            and start the checks.
          </span>
        </Col>
        <Col className="d-block d-lg-none d-xs-block d-md-block d-sm-block mt-4">
          <p className="exp-text">Experience will launch in a new window</p>
          <Buttons
            className="primary"
            name="Continue"
            handleClick={() => {
              window.open(QRcodeURL, "_blank"); //to open new window
            }}
            testId="continue-button"
          />
        </Col>

        {/* <Col lg={1}></Col> */}
      </Row>
    </div>
  );
};

export default QRCodeModal;
